// @flow

import type { JSONValue } from 'common/types';
import { type Money, money } from 'common/types/money';
import { object, record, number, locale } from 'common/json/extract';

const extractValues = object(
  record({
    currency: locale,
    amount: number
  })
);

export default function moneyExtract(json: JSONValue): Money {
  const extractedMoney = extractValues(json);
  return money(extractedMoney.currency, extractedMoney.amount);
}
